import { gql } from '@apollo/client';

export const GET_MESSAGE_THREADS = gql`
  query MessageThreads($limit: Int!, $offset: Int!) {
    currentUser {
      messageThreads(limit: $limit, offset: $offset) {
        totalCount
        items {
          id
          subject
          participants {
            id
            name
            avatarImageUrl
            isOnline
            lastActiveAt
          }
          latestMessage {
            id
            content
            sentAt
          }
          latestMessageSentBy {
            id
            name
            avatarImageUrl
          }
          unreadMessageCount
        }
      }
    }
  }
`;
